<app-modal [isOpen]="isOpen" (close)="onClose()" className="max-w-3xl mx-4 sm:mx-6">
  <div class="p-6 sm:p-8">
    <!-- Loading -->
    @if (loading) {
      <div class="flex items-center gap-3 py-12 justify-center">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
        <span class="text-sm text-gray-500 dark:text-gray-400">Cargando correo...</span>
      </div>
    }

    <!-- Error -->
    @if (!loading && error) {
      <div class="rounded-lg bg-error-50 dark:bg-error-500/15 p-4 text-sm text-error-700 dark:text-error-400">
        {{ error }}
      </div>
    }

    @if (!loading && email) {
      <!-- Header -->
      <div class="flex items-start gap-4 mb-6">
        <div class="flex-shrink-0">
          <div class="flex h-14 w-14 items-center justify-center rounded-full bg-success-50 text-success-600 dark:bg-success-500/15 dark:text-success-400">
            <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
          </div>
        </div>
        <div class="flex-1 min-w-0">
          <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-success-50 text-success-700 dark:bg-success-500/15 dark:text-success-400">
            Correo recibido
          </span>
          <h2 class="mt-2 text-xl font-bold text-gray-900 dark:text-white break-words">
            {{ email.subject || '(Sin asunto)' }}
          </h2>
          <div class="mt-2 flex items-center gap-2 flex-wrap">
            <span class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(email.receivedAt) }}</span>
            @if (email.isRead === false) {
              <span class="text-xs text-gray-400 dark:text-gray-500">·</span>
              <span class="inline-flex items-center gap-1 text-xs font-medium text-brand-600 dark:text-brand-400">
                <span class="h-2 w-2 rounded-full bg-brand-500"></span> No leído
              </span>
            } @else if (email.isRead === true) {
              <span class="text-xs text-gray-400 dark:text-gray-500">·</span>
              <span class="text-xs text-gray-500 dark:text-gray-400">Leído</span>
            }
          </div>
        </div>
      </div>

      <div class="space-y-6">
        <!-- De / Para / CC -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">De</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white break-all">
              {{ email.fromName ? email.fromName + ' <' + (email.fromEmail || '—') + '>' : (email.fromEmail || '—') }}
            </p>
          </div>
          @if (toAddresses.length > 0) {
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Para</p>
              <p class="text-sm font-medium text-gray-900 dark:text-white break-all">{{ toAddresses.join(', ') }}</p>
            </div>
          }
          @if (ccAddresses.length > 0) {
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">CC</p>
              <p class="text-sm font-medium text-gray-900 dark:text-white break-all">{{ ccAddresses.join(', ') }}</p>
            </div>
          }
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Canal</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ channelTypeLabel(email.channelType) }}</p>
          </div>
        </div>

        <!-- Adjuntos (indicador) -->
        @if (email.hasAttachments) {
          <div class="flex items-center gap-2 rounded-lg bg-gray-50 dark:bg-gray-800/50 p-3 text-sm text-gray-700 dark:text-gray-300">
            <svg class="w-5 h-5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path>
            </svg>
            Este correo tiene adjuntos.
          </div>
        }

        <!-- Cuerpo -->
        <div>
          <h3 class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">
            Cuerpo del mensaje
          </h3>
          @if (email.bodyHtml) {
            <div class="prose prose-sm dark:prose-invert max-w-none rounded-lg border border-gray-200 dark:border-gray-700 p-4 overflow-x-auto text-gray-900 dark:text-gray-100"
                 [innerHTML]="email.bodyHtml | safeHtml"></div>
          } @else if (email.bodyText) {
            <pre class="whitespace-pre-wrap break-words rounded-lg border border-gray-200 dark:border-gray-700 p-4 text-sm text-gray-900 dark:text-gray-100 font-sans">{{ email.bodyText }}</pre>
          } @else {
            <p class="text-sm text-gray-400 dark:text-gray-500">El cuerpo de este correo no está disponible.</p>
          }
        </div>
      </div>
    }
  </div>
</app-modal>
